function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import Vue from 'vue';
import { Wormhole } from 'portal-vue';

var FormSidepanel = /*#__PURE__*/function () {
  function FormSidepanel() {
    _classCallCheck(this, FormSidepanel);
  }

  _createClass(FormSidepanel, null, [{
    key: "register",
    value: function register() {
      Vue.component('roche-sidepanel', {
        template: "<div ref=\"sidepanelWrapper\">\n          <a class=\"sidepanel-opener\" @click=\"openPanel\" ref=\"opener\" v-if=\"fixed && visible\">{{fixed}}</a>\n          <slot name=\"activator\" :togglePanel=\"togglePanel\" :openPanel=\"openPanel\"></slot>\n          <portal to=\"sidepanel\"></portal>\n        </div>",
        data: function data() {
          return {
            id: Math.random().toString(36).substr(2, 9),
            panelEl: document.querySelector('.form-sidepanel'),
            visible: true
          };
        },
        props: ['value', 'open', 'fixed'],
        watch: {
          value: function value(newValue) {
            if (newValue) this.openPanel();
          },
          open: function open(newValue) {
            if (newValue) this.openPanel();
          }
        },
        methods: {
          togglePanel: function togglePanel() {
            if (this.hasContent()) {
              Wormhole.open({
                to: 'sidepanel',
                from: 'sidepanel',
                passengers: this.$slots["default"]
              });
              var panelId = this.panelEl.getAttribute('data-content-id');

              if (!this.panelEl.classList.contains('open')) {
                this.panelEl.classList.add('open');
              } else if (panelId === this.id) {
                this.panelEl.classList.toggle('open');
              }

              this["this"].panelEl.setAttribute('data-content-id', this.id);
              this.$emit('input', false);
            } else {
              this.panelEl.classList.remove('open');
            }
          },
          openPanel: function openPanel() {
            if (this.hasContent()) {
              Wormhole.open({
                to: 'sidepanel',
                from: 'sidepanel',
                passengers: this.$slots["default"]
              });
              this.panelEl.classList.add('open');
              this.panelEl.setAttribute('data-content-id', this.id);
              this.$emit('input', false);
            } else {
              this.panelEl.classList.remove('open');
            }
          },
          isElementInViewport: function isElementInViewport(el) {
            var _el$getBoundingClient = el.getBoundingClientRect(),
                right = _el$getBoundingClient.right,
                left = _el$getBoundingClient.left;

            return right > 0 && left < (window.innerWidth || document.documentElement.clientWidth);
          },
          hasContent: function hasContent() {
            try {
              var el = this.$slots["default"][0];

              if (el && el.children) {
                return !!el.children[0].text || !!el.children[0].children[0];
              }

              return false;
            } catch (error) {
              return false;
            }
          },
          checkIfVisible: function checkIfVisible() {
            var _this = this;

            this.$root.$on('step-changed', function () {
              _this.$nextTick(function () {
                if (_this.$refs.opener) {
                  _this.panelEl = document.querySelector('.form-sidepanel');
                  var isDesktop = _this.$refs.opener.offsetParent === null;

                  if (_this.isElementInViewport(_this.$refs.sidepanelWrapper) && isDesktop) {
                    _this.openPanel();
                  }
                }
              });
            });
          }
        },
        mounted: function mounted() {
          this.$root.$on('close-sidepanel', function () {
            document.querySelector('.form-sidepanel').classList.remove('open');
          });
          if (this.fixed) this.checkIfVisible();
          this.visible = this.hasContent();
        }
      });
    }
  }]);

  return FormSidepanel;
}();

export default FormSidepanel;